// intitialize validation settings
ko.validation.init({
    insertMessages: false,
    messageTemplate: null,
    //messagesOnModified: false,
    grouping: { deep: true, observable: true }
}, true);